import React from 'react'

// bootstrap
import {
    Col
} from 'react-bootstrap'

// app inputs
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'
import AppFormikTextareaInline from 'utlis/helpers/forms/AppFormikTextareaInline'
import AppFormHTMLFieldInline from 'utlis/helpers/forms/AppFormHTMLFieldInline'

// images upload
import ImagesUploader from './ImagesUploader'

export default function CategoriesForm(props) {
    // props
    const {
        formik,

        categoryImage,
        currentCategoryImage,
        setCurrentCategoryImage,
        setIsImageDeleted,
    } = props

    // get descriptions
    const getResult = (data) => {
        // setting the description value
        formik.setFieldValue("description", data)
    }

    return (
        <React.Fragment>
            {/* app card */}
            <div className="app-card mb-3">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize st-text-light">Basic Info</p>
                </div>

                {/* card content */}
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                    <Col xs={12} md={9} lg={8} className="px-0">
                        {/* form field */}
                        <AppFormikInputInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Category Name"} // label name
                            isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Category Name"} // placeholder for the input
                            formikFieldName={"categoryName"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikSelectInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Status"} // label name
                            formikFieldName={"status"} // important: formik value name for the input
                        >
                            <option disabled value="">Select Status</option>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                        </AppFormikSelectInline>
                    </Col>
                </div>
            </div>

            {
                /* app card */
                true ? (
                    <div className="app-card mb-3">
                        {/* card heading */}
                        <div className="app-header-wrapper heading-sm mb-1">
                            {/* heading */}
                            <p className="app-heading text-capitalize st-text-light">Images</p>
                        </div>

                        {/* card content */}
                        <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                            <Col xs={12} md={9} lg={8} className="px-0">
                                <ImagesUploader
                                    categoryImage={categoryImage}
                                    currentCategoryImage={currentCategoryImage}
                                    setCurrentCategoryImage={setCurrentCategoryImage}
                                    setIsImageDeleted={setIsImageDeleted}
                                />
                            </Col>
                        </div>
                    </div>
                ) : null
            }

            {/* app card */}
            <div className="app-card mb-3">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize st-text-light">Description</p>
                </div>

                {/* card content */}
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-TB">
                    <Col xs={12} lg={10} className="px-0">
                        <AppFormHTMLFieldInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap"} // class name for main wrapper
                            labelName={"Description"} // label name
                            placeholder={"Description"} // placeholder for the input
                            formikFieldName={"description"} // important: formik value name for the input
                            getResult={getResult} // to get the result
                        />
                    </Col>
                </div>
            </div>

            {/* app card */}
            <div className="app-card mb-3">
                {/* card heading */}
                <div className="app-header-wrapper heading-sm mb-1">
                    {/* heading */}
                    <p className="app-heading text-capitalize st-text-light">Search Engine Optimization</p>
                </div>

                {/* card content */}
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                    <Col xs={12} md={9} lg={8} className="px-0">
                        {/* form field */}
                        <AppFormikInputInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Meta Title"} // label name
                            placeholder={"Meta Title"} // placeholder for the input
                            formikFieldName={"metaTitle"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikTextareaInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap"} // class name for main wrapper
                            labelName={"Meta Description"} // label name
                            placeholder={"Meta Description"} // placeholder for the input
                            textareaRows={"4"} // rows for textarea
                            formikFieldName={"metaDescription"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikInputInline
                            formik={formik} // formik object
                            stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                            labelName={"Meta Keywords"} // label name
                            placeholder={"Meta Keywords"} // placeholder for the input
                            formikFieldName={"metaKeyword"} // important: formik value name for the input
                        />

                    </Col>
                </div>
            </div>
        </React.Fragment>
    )
}
